export default __webpack_public_path__ + "static/media/ai-drop-zone-hover.8428a943.svg";